<script>
import { mapState, mapGetters } from 'vuex'
import { mixin, sortByTimestamp } from '@/components/common'
import subPageContainer from '@/components/sub-page-container'
import receiptList from '@/components/view/receipt-list'
import footer from '@/components/view/c-footer'
import lp from '@/components/view/lp'
export default {
  mixins: [mixin],
  components: {
    'sub-page-container': subPageContainer,
    'receipt-list': receiptList,
    'c-footer': footer,
    'c-lp': lp
  },
  computed: {
    ...mapGetters([
      'isSignIn'
    ]),
    ...mapState({
      user: 'user',
      anonymous: 'anonymous',
      currentList: 'mypageCurrentList'
    }),
    histories () {
      return this.user.histories && this.user.histories.length ? this.user.histories : []
    },
    wishlists () {
      return sortByTimestamp(this.user.wishlists, 'created', 'desc')
    },
    receipts () {
      return sortByTimestamp(this.user.receipts, 'created', 'desc')
    }
  },
  watch: {
    currentList (value) {
      if (value === 3) {
        this.$store.dispatch('fetchReceipts')
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="mypage main-page">
      <div
        class="tabs is-centered is-cs-4"
        v-if="wishlists.length || histories.length"
      >
        <ul>
          <li
            :class="{'is-active': currentList === 1}"
            @click="$store.commit('setMypageCurrentList', 1)"
          >
            <a>ほしいリスト</a>
          </li>
          <li
            :class="{'is-active': currentList === 2}"
            @click="$store.commit('setMypageCurrentList', 2)"
          >
            <a>最近の履歴</a>
          </li>
          <li
            :class="{'is-active': currentList === 3}"
            @click="$store.commit('setMypageCurrentList', 3)"
          >
            <a>レシート</a>
          </li>
        </ul>
      </div>
      <div
        v-if="user.uid"
        :class="{'lp-margin': isSignIn}"
      >
        <div
          class="page-list"
          v-if="currentList === 1"
        >
          <ul class="flex-list">
            <cachalog-page-list
              v-for="page in wishlists"
              :page="page"
              :key="page.id"
            />
          </ul>
        </div>
        <div
          class="page-list"
          v-if="currentList === 2"
        >
          <ul class="flex-list">
            <cachalog-page-list
              v-for="page in histories"
              :page="page"
              :key="page.id"
            />
          </ul>
        </div>
        <div
          class="receipt-list"
          v-if="currentList === 3"
        >
          <ul class="flex-list">
            <receipt-list
              v-for="receipt in receipts"
              :receipt="receipt" :key="receipt.id"
              :route="{uid: user.uid, receiptId: receipt.id}"
            />
          </ul>
          <div class="has-text-centered" v-if="anonymous">
            <p class="is-cs-5 is-c-alert-text">レシートを残すにはログインが必要です</p>
            <router-link :to="{name: 'sign-in'}">
              <button class="button is-rounded is-c-primary is-cs-4 is-large">
                ログイン
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <c-lp v-if="!isSignIn"/>
      <c-footer v-else/>
    </div>
    <sub-page-container v-if="user.uid">
      <router-view
        name="page-sub"
        class="sub-page"
      />
    </sub-page-container>
  </div>
</template>

<style scoped>
.mypage .tabs {
  padding-top: 1rem;
  margin-bottom: 1rem;
}
.mypage .tabs li {
  width: 50%;
}
.mypage .lp-margin {
  min-height: calc(100vh - 24rem)
}
.mypage .page-list li {
  padding-bottom: 1rem;
}
.mypage .page-list li:last-child,
.mypage .page-list li:nth-last-child(2):nth-child(odd) {
  margin-bottom: 2rem;
}

.receipt-list button {
  margin: 1rem auto 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mypage.vue